@if (!loading())
{
<mat-card>
  <mat-card-header>
    <mat-card-title>Problems</mat-card-title>
    <a mat-button (click)="onCreateProblem()" color="primary">
      Add Problem
    </a>
  </mat-card-header>
  <mat-card-content>
    <!--Problem auto complete-->
    <app-problem-auto-complete [problems]="searchProblems"
                               [hasMore]="hasMore()"
                               (onProblemSelect)="navigateToProblemManage($event)"
                               (onLoadMore)="loadMoreProblems()"
                               (onQueryChange)="handleQueryChange($event)">
      <!--End Problem auto complete-->

    </app-problem-auto-complete>
    <mat-accordion>
      <!--Topic Start -->

      @for (problem of paginatedProblems(); track problem.id)
      {
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>{{problem.title}}</mat-panel-title>
            <button mat-button color="primary" (click)="onManageProblem(problem.id)">
              Manage
            </button>
            <button mat-button color="primary" (click)="onEditProblem(problem.id)">
              Edit
            </button>
          </mat-expansion-panel-header>

          <div class="row">
            <div class="col-6">
              <mat-card-subtitle>Content</mat-card-subtitle>
              <app-ck-editor [readonlyData]=problem.content [inline]="true" [readonly]="true"></app-ck-editor>
            </div>

            @if (problem.topic; as topic)
            {
            <div class="col-6">
              <mat-card-subtitle>Subject</mat-card-subtitle>
              <h3 mat-line>{{topic.subject}}</h3>

              <mat-card-subtitle>Difficulty</mat-card-subtitle>
              <h3 mat-line>{{problem.difficulty}}</h3>

              <mat-card-subtitle>Topic</mat-card-subtitle>
              <h3 mat-line>{{topic.displayName}}</h3>
            </div>
            }
          </div>

          <!-- Problem Start-->
          <!--<app-solution-list [solutions]="problem.solutions" [problemId]="problem.id"></app-solution-list>-->

        </mat-expansion-panel>
      }
      <!--Problems End-->
      <!--Topic End -->
    </mat-accordion>
  </mat-card-content>
  @if (showPagination)
  {
    <mat-paginator [length]="length"
                   [pageSize]="pageSize"
                   [pageIndex]="pageIndex"
                   [pageSizeOptions]="pageSizeOptions"
                   [selectConfig]="{ panelClass: 'paginator-page-size-panel' }"
                   (page)="getProblemsPagination($event)">
    </mat-paginator>
  }
</mat-card>
} @else
{
  <app-spinner></app-spinner>
}
